import { AnthropicLogo, OpenAILogo } from '@/components/Landing/ProviderLogos'

type TutorialToolLogoProps = {
  toolId: string
  size?: number
  className?: string
}

/** Simple Icons CDN — openai slug removed; python / cursor / anthropic still available */
const CDN_BRANDS: Record<string, { slug: string; color: string }> = {
  'python-sdk': { slug: 'python', color: '3776AB' },
  cursor: { slug: 'cursor', color: '000000' },
}

function CdnBrandIcon({
  slug,
  color,
  size,
  className,
}: {
  slug: string
  color: string
  size: number
  className?: string
}) {
  return (
    <img
      src={`https://cdn.simpleicons.org/${slug}/${color}`}
      alt=""
      width={size}
      height={size}
      className={className}
      aria-hidden
      loading="lazy"
    />
  )
}

function MonogramLogo({
  label,
  bg,
  fg = '#fff',
  size = 28,
  className,
}: {
  label: string
  bg: string
  fg?: string
  size?: number
  className?: string
}) {
  return (
    <span
      className={className}
      aria-hidden
      style={{
        width: size,
        height: size,
        background: bg,
        color: fg,
        borderRadius: 8,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size * 0.38,
        fontWeight: 700,
        letterSpacing: '-0.04em',
        flexShrink: 0,
      }}
    >
      {label}
    </span>
  )
}

export default function TutorialToolLogo({ toolId, size = 28, className }: TutorialToolLogoProps) {
  const cdnBrand = CDN_BRANDS[toolId]
  if (cdnBrand) {
    return (
      <CdnBrandIcon
        slug={cdnBrand.slug}
        color={cdnBrand.color}
        size={size}
        className={className}
      />
    )
  }

  switch (toolId) {
    case 'claude-code':
      return <AnthropicLogo size={size} className={`text-[#191919] ${className ?? ''}`} />
    case 'codex-cli':
      return <OpenAILogo size={size} className={`text-[#412991] ${className ?? ''}`} />
    case 'cc-switch':
      return <MonogramLogo label="CC" bg="#0891B2" size={size} className={className} />
    case 'cherry-studio':
      return <MonogramLogo label="CS" bg="#059669" size={size} className={className} />
    case 'chatbox':
      return <MonogramLogo label="CB" bg="#D97706" size={size} className={className} />
    default:
      return <OpenAILogo size={size} className={`text-[#412991] ${className ?? ''}`} />
  }
}
